import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/company-logo.png";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-12`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

// Phone and email side by side on one line, centered
const ContactContainer = tw.div`mt-10 flex flex-wrap items-center justify-center text-center font-medium text-sm text-gray-400`;
const ContactItem = tw.p`mx-3 whitespace-nowrap`;
// Divider only on wider screens; on phones phone and email stack as two centered lines
const ContactDivider = tw.span`hidden sm:inline text-gray-600`;
const ContactLink = tw.a`text-gray-100 border-b border-transparent hocus:border-gray-300 transition duration-300`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
            <LogoText>CYBER LEEWAY</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link href="#">Home</Link>
            <Link href="#about">About</Link>
            <Link href="#contact">Contact Us</Link>
            <Link href="/privacy-policy">Privacy Policy</Link>
            <Link href="/terms-and-conditions">Terms &amp; Conditions</Link>
            {/* Hidden until these sections are available */}
            {/* <Link href="#">Blog</Link> */}
            {/* <Link href="#testimonials">Reviews</Link> */}
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://youtube.com">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
          <ContactContainer>
            <ContactItem>
              Phone: <ContactLink href="tel:+94775551342">+94 (0)775551342</ContactLink>
            </ContactItem>
            <ContactDivider>|</ContactDivider>
            <ContactItem>
              Email: <ContactLink href="mailto:info.cyberleeway@gmail.com">info.cyberleeway@gmail.com</ContactLink>
            </ContactItem>
          </ContactContainer>
          <CopyrightText>
            &copy; 2026 Cyber Leeway (PVT) Ltd. All rights reserved.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
